import Alpine from 'alpinejs';
import IMask from 'imask';


Alpine.store('formValidVac', {
    contactForm: {
        name: '',
        surname: '',
        email: '',
        phone: '',
        message: '',
        resume: null,
        job_position_id:'',
    },

    contactErrors: {
        name: null,
        surname: null,
        email: null,
        phone: null,
        resume: null,
    },

    validateContactForm() {
        const emailPattern = /^[^\s@()]+@[^\s@]+\.[^\s@]+$/;
        const namePattern = /^[A-Za-zА-Яа-яЁёЇїІіЄєҐґ'’\- ]+$/;
        const phonePattern = /^\+38\(\d{3}\)\d{3}-\d{2}-\d{2}$/;

        this.contactErrors = {
            name: !this.contactForm.name
                ? 'Заповніть це поле'
                : this.contactForm.name.length < 2
                    ? 'Ім’я повинно містити хоча б 2 символи'
                    : !namePattern.test(this.contactForm.name)
                        ? 'Ім’я повинно містити тільки літери'
                        : null,

            surname: !this.contactForm.surname
                ? 'Заповніть це поле'
                : this.contactForm.surname.length < 2
                    ? 'Прізвище повинно містити хоча б 2 символи'
                    : !namePattern.test(this.contactForm.surname)
                        ? 'Прізвище повинно містити тільки літери'
                        : null,

            email: !this.contactForm.email
                ? 'Заповніть це поле'
                : !emailPattern.test(this.contactForm.email)
                    ? 'Введіть коректний email'
                    : null,

            phone: !this.contactForm.phone
                ? 'Заповніть це поле'
                : !phonePattern.test(this.contactForm.phone)
                    ? 'Введіть коректний номер телефону'
                    : null,

            resume: !this.contactForm.resume
                ? 'Завантажте резюме'
                : null,
        };

        if (!Object.values(this.contactErrors).some(error => error)) {
            this.sendFormContact();
        }
    },

    sendFormContact() {
        const formData = new FormData();
        formData.append('name', this.contactForm.name);
        formData.append('surname', this.contactForm.surname);
        formData.append('email', this.contactForm.email);
        formData.append('phone', this.contactForm.phone);
        formData.append('message', this.contactForm.message);
        formData.append('resume', this.contactForm.resume);
        formData.append('job_position_id', document.getElementById('job_position_id')?.value || '');

        fetch('/api/v1/store/job_requests', {
            method: 'POST',
            body: formData,
        })
            .then(async response => {
                if (!response.ok) throw new Error('Network error');
                this.clearFormContact();
                Toastify({
                    text: "Успішно",
                    duration: 2000,
                    destination: "https://github.com/apvarun/toastify-js",
                    newWindow: true,
                    close: true,
                    gravity: "top",
                    position: "right",
                    style: {
                        background: "#28a745",
                        color: "#fff"
                    }
                }).showToast();
            })
            .catch(error => console.error(error));
    },

    clearFormContact() {
        this.contactForm = {
            name: '',
            surname: '',
            email: '',
            phone: '',
            message: '',
            resume: null,
            job_position_id: this.contactForm.job_position_id,
        };
        this.contactErrors = {
            name: null,
            surname: null,
            email: null,
            phone: null,
            resume: null,
        };

        const fields = ['name', 'surname', 'email', 'phone', 'message'];
        fields.forEach(field => {
            const input = document.querySelector(`input[name="${field}"]`);
            if (input) input.value = '';
        });

        const file = document.getElementById('resumeInput');
        if (file) file.value = '';
        const addResumeBtn = document.getElementById('addResumeBtn');
        if (addResumeBtn) {
            addResumeBtn.innerText = addResumeBtn.dataset.default || '📎 Додати резюме';
        }
    }
});
const resumeInput = document.getElementById('resumeInput');
const addResumeBtn = document.getElementById('addResumeBtn');

addResumeBtn?.addEventListener('click', () => {
    resumeInput?.click();
});

resumeInput?.addEventListener('change', (e) => {
    const file = e.target.files[0];
    if (file) {
        const validTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
        const maxSize = 5 * 1024 * 1024;

        if (!validTypes.includes(file.type)) {
            Alpine.store('formValidVac').contactErrors.resume = 'Допустимі формати: PDF, DOC, DOCX';
            Alpine.store('formValidVac').contactForm.resume = null;
            return;
        }

        if (file.size > maxSize) {
            Alpine.store('formValidVac').contactErrors.resume = 'Розмір файлу перевищує 5MB';
            Alpine.store('formValidVac').contactForm.resume = null;
            return;
        }

        Alpine.store('formValidVac').contactForm.resume = file;
        Alpine.store('formValidVac').contactErrors.resume = null;

        addResumeBtn.innerText = `📎 ${file.name}`;
    }
});

